export enum GeoFieldType {
  Geography = 'geography',
  Geometry = 'geometry',
  Binary = 'binary'
}

export const isGeomField = (type: string) => {
  return (
    type?.toLowerCase() === GeoFieldType.Geography ||
    type?.toLowerCase() === GeoFieldType.Geometry ||
    type?.toLowerCase() === GeoFieldType.Binary
  )
}
